import React from 'react';
import { DatePicker } from 'rsuite';

export default function MonthPickerComponent(props) {

	const { defaultValue, disabledDate, placement, size, placeholder } = props;
	const { dateChange } = props;

	const style = {
		padding: '0',
	};

	return (
		<DatePicker
			size={size || "md"}
			placeholder={placeholder || "Select Month"}
			appearance="subtle"
			className="form-control"
			format='yyyy-MM'
			oneTap
			style={style}
			placement={placement}
			disabledDate={disabledDate}
			defaultValue={defaultValue}
			onChange={(value) => {
				dateChange(value);
			}}
			cleanable={true}
		/>
	);
}
